import { useActivityContext } from './Context'
import { appShellPermissions } from '@ztechapps/common.contract'
import { useRole } from '@ztechapps/common.hook'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { BusyButtonLink } from '@ztechapps/webui.button'
import React from 'react'

export const ShowHistoryButton = () => {
  const { setShowHistory, showHistory, historyFilter } = useActivityContext()
  const { hasRole: canViewHistory } = useRole({ roleName: appShellPermissions.history.canView.value })

  return (
    <ShowIf condition={!!historyFilter}>
      <HorizontalStack className="justify-content-start py-2">
        <BusyButtonLink
          bsSize="sm"
          icon="list"
          text={showHistory ? 'Hide History' : 'Show History'}
          onClick={() => setShowHistory()}
          disabledReason={canViewHistory ? undefined : 'You need the View History permission to see history.'}
        />
      </HorizontalStack>
    </ShowIf>
  )
}
